module.exports = __webpack_public_path__ + "static/media/nami-lose.b6498f44.png";